// extracted by mini-css-extract-plugin
export default {"mainTextHide":"MainCTA_mainTextHide__1oKtm","miniTag":"MainCTA_miniTag__5+lct","logoLg":"MainCTA_logoLg__BLmd4"};